import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DailyOfferStateService {

  showOffer$ = new BehaviorSubject<boolean>(false);
  timer$ = new BehaviorSubject<string>('00:00:00');
  progress$ = new BehaviorSubject<number>(100);

  private intervalId: any;
  private isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  start(): void {
    if (!this.isBrowser) return;

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);

    const tick = () => {
      const remaining = Math.floor(
        (endOfDay.getTime() - Date.now()) / 1000
      );

      if (remaining <= 0) {
        this.showOffer$.next(false);
        clearInterval(this.intervalId);
        return;
      }

      this.updateTimerUI(remaining);
      this.updateProgress24h(remaining);
    };

    this.showOffer$.next(true);
    tick();
    this.intervalId = setInterval(tick, 1000);
  }

  private updateTimerUI(seconds: number): void {
    const h = Math.floor(seconds / 3600).toString().padStart(2, '0');
    const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');

    this.timer$.next(`${h}:${m}:${s}`);
  }

  private updateProgress24h(remainingSeconds: number): void {
    const total = 24 * 60 * 60;
    this.progress$.next(
      Math.round((remainingSeconds / total) * 100)
    );
  }

  stop(): void {
    clearInterval(this.intervalId);
    this.showOffer$.next(false);
  }
}
